import { DataGridProProps, GridValidRowModel } from '@mui/x-data-grid-pro';

import { DataGridProStyled } from './DataGridCustom.styled';
import { getRowId } from './util/internalRowIds';

export const DataGridCustom = <R extends GridValidRowModel = any>(props: DataGridProProps<R>) => {
  return (
    <DataGridProStyled
      hideFooter
      disableColumnMenu
      disableColumnSelector
      disableRowSelectionOnClick
      getRowId={getRowId}
      {...props}
    />
  );
};
